export const referralProgramDetailsMessages = {
  pageTitle: 'Referrals',
  pageSubtitle: 'Incentivize members to refer their friends',
  notConfiguredTitle: 'Set up a Referral Program',
  notConfiguredDescription:
    'Set up your referral program and use points or awards to get new members!',
  startConfigurationButtonText: 'Get started',
};
